import { render, staticRenderFns } from "./SendMessagePopup.vue?vue&type=template&id=5bb3b5c0&scoped=true&"
import script from "./SendMessagePopup.vue?vue&type=script&lang=ts&"
export * from "./SendMessagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendMessagePopup.vue?vue&type=style&index=0&id=5bb3b5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3b5c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb3b5c0')) {
      api.createRecord('5bb3b5c0', component.options)
    } else {
      api.reload('5bb3b5c0', component.options)
    }
    module.hot.accept("./SendMessagePopup.vue?vue&type=template&id=5bb3b5c0&scoped=true&", function () {
      api.rerender('5bb3b5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendMessagePopup.vue"
export default component.exports